<template>
    <div
        v-if="isPageLoaded"
        class="area-guide"
    >
        <div class="hero-banner">
            <div class="container text-center white--text">
                <v-row
                    justify="center"
                    class="ma-0 mb-4 mb-md-8 mb-lg-14"
                >
                    <v-col cols="12" class="pa-lg-0">
                        <h1>{{ page.areaGuideTitle }}</h1>
                    </v-col>
                </v-row>

                <v-row
                    justify="center"
                    class="ma-0 mb-2 mb-md-6"
                >
                    <v-col cols="12" class="pa-lg-0">
                        <h2>{{ page.areaGuideSubtitle }}</h2>
                    </v-col>
                </v-row>

                <v-row
                    v-if="page.areaGuideDescription"
                    justify="center"
                    class="ma-0 mb-4 mb-md-8 mb-lg-14"
                >
                    <v-col cols="10" sm="8" md="7" lg="6" class="pa-lg-0">
                        <p>{{ page.areaGuideDescription }}</p>
                    </v-col>
                </v-row>

                <v-row class="ma-0 mb-2 mb-md-6">
                    <v-col class="justify-center d-flex pa-lg-0">
                        <v-btn
                            color="primary"
                            depressed
                            large
                            v-on:click.prevent="scrollToSection('#area-guide-download')"
                        >
                            Download Area Guide
                        </v-btn>
                    </v-col>
                </v-row>
            </div>
        </div>

        <div class="navigation-buttons section section-dark">
            <div class="content">
                <v-row>
                    <v-col
                        v-for="(navButton, index) in navigationButtons"
                        :key="index"
                        cols="12"
                        md="6"
                        lg="4"
                    >
                        <v-btn
                            block
                            color="primary"
                            depressed
                            large
                            class="px-4"
                            v-on:click.prevent="scrollToSection(navButton.navSection)"
                        >
                            {{ navButton.btnTitle }}
                            <v-icon color="white" size="22">mdi-chevron-right</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </div>
        </div>

        <div id="activities" class="activities section">
            <div class="content">
                <v-row>
                    <v-col class="pa-lg-0">
                        <h2>{{ page.activitiesTitle }}</h2>
                    </v-col>
                </v-row>

                <v-row
                    v-if="page.activitiesDescription"
                    justify="center"
                    class="my-8"
                >
                    <v-col lg="7">
                        <p>{{ page.activitiesDescription }}</p>
                    </v-col>
                </v-row>

                <activity-block
                    v-for="(activity, index) in activities"
                    :key="activity.id"
                    :activity="activity"
                    :index="index + 1"
                    :reverse="index % 2 === 1"
                ></activity-block>

                <v-row class="mt-8">
                    <v-col class="justify-center d-flex pa-0">
                        <v-btn
                            color="primary"
                            depressed
                            large
                            v-on:click.prevent="scrollToSection('#area-guide-download')"
                        >
                            Download Area Guide
                        </v-btn>
                    </v-col>
                </v-row>
            </div>
        </div>

        <div id="eateries" class="eateries section section-dark">
            <div class="content">
                <v-row>
                    <v-col class="pa-lg-0">
                        <h2>{{ page.eateriesTitle }}</h2>
                    </v-col>
                </v-row>

                <v-row
                    v-if="page.eateriesDescription"
                    justify="center"
                    class="my-8"
                >
                    <v-col lg="7">
                        <p>{{ page.eateriesDescription }}</p>
                    </v-col>
                </v-row>

                <v-row class="justify-start mb-10">
                    <v-col
                        v-for="eatery in eateries"
                        :key="eatery.id"
                        cols="12"
                        sm="6"
                        md="4"
                        lg="3"
                    >
                        <eatery-card :eatery="eatery"></eatery-card>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col class="justify-center d-flex pa-0">
                        <v-btn
                            color="primary"
                            depressed
                            large
                            v-on:click.prevent="scrollToSection('#area-guide-download')"
                        >
                            Download Area Guide
                        </v-btn>
                    </v-col>
                </v-row>
            </div>
        </div>

        <div id="local-tours" class="local-tours section">
            <div class="content">
                <v-row>
                    <v-col class="pa-lg-0">
                        <h2>{{ page.localToursTitle }}</h2>
                    </v-col>
                </v-row>

                <v-row
                    v-if="page.localToursDescription"
                    justify="center"
                    class="my-8"
                >
                    <v-col md="7">
                        <p>{{ page.localToursDescription }}</p>
                    </v-col>
                </v-row>

                <v-row class="justify-start mb-10">
                    <v-col
                        v-for="tour in tours"
                        :key="tour.id"
                        cols="12"
                        md="6"
                    >
                        <tour-card :tour="tour"></tour-card>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col class="justify-center d-flex pa-0">
                        <v-btn
                            color="primary"
                            depressed
                            large
                            v-on:click.prevent="scrollToSection('#area-guide-download')"
                        >
                            Download Area Guide
                        </v-btn>
                    </v-col>
                </v-row>
            </div>
        </div>

        <div id="outings" class="outings section section-dark">
            <div class="content">
                <v-row>
                    <v-col cols="12" md="5" class="pa-0 mb-12 mb-md-0">
                        <div class="text-center text-md-left">
                            <v-row class="ma-0 mb-12">
                                <v-col class="pa-md-0">
                                    <h2>{{ page.outingsTitle }}</h2>
                                </v-col>
                            </v-row>

                            <v-row
                                v-if="page.outingsDescription"
                                class="ma-0 mb-12"
                            >
                                <v-col class="pa-md-0">
                                    <p>{{ page.outingsDescription }}</p>
                                </v-col>
                            </v-row>

                            <v-row class="ma-0 mb-12">
                                <v-col class="pa-0 d-flex justify-center justify-md-start">
                                    <v-btn
                                        color="primary"
                                        depressed
                                        large
                                        v-on:click.prevent="scrollToSection('#area-guide-download')"
                                    >
                                        Download Area Guide
                                    </v-btn>
                                </v-col>
                            </v-row>

                            <v-row class="ma-0">
                                <v-col class="pa-md-0">
                                    <div class="outings-image-wrapper elevation-8">
                                        <v-img
                                            eager
                                            :src="getImageUrl(page.outingsImage)"
                                            :alt="getImageAltText(page.outingsImage)"
                                        ></v-img>
                                    </div>
                                </v-col>
                            </v-row>
                        </div>
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-col cols="12" md="6" class="pa-0">
                        <v-expansion-panels flat multiple tile class="px-4 px-md-0">
                            <outing-panel
                                v-for="(outing, index) in outings"
                                :key="outing.id"
                                :outing="outing"
                                :index="index + 1"
                            ></outing-panel>
                        </v-expansion-panels>
                    </v-col>
                </v-row>
            </div>
        </div>

        <div id="area-guide-download" class="area-guide-download section section-dark">
            <div class="content my-0">
                <v-row>
                    <v-col cols="12" md="6" lg="5" class="download-content">
                        <div class="text-center text-md-left">
                            <v-row class="ma-0 mb-10">
                                <v-col class="pa-md-0">
                                    <h2>{{ page.downloadTitle }}</h2>
                                </v-col>
                            </v-row>

                            <v-row class="ma-0 mb-10">
                                <v-col class="pa-md-0">
                                    <p>{{ page.downloadDescription }}</p>
                                </v-col>
                            </v-row>

                            <v-row class="ma-0">
                                <v-col class="pa-md-0">
                                    <v-card
                                        class="email-form"
                                        outlined
                                    >
                                        <v-card-actions>
                                            <v-text-field
                                                v-model="emailAddress"
                                                :disabled="!isDownloadFileLoaded"
                                                :error-messages="emailErrors"
                                                required
                                                outlined
                                                hide-details="auto"
                                                background-color="white"
                                                class="btn-edu-height"
                                                placeholder="Enter Your E-mail Address"
                                                v-on:input="$v.emailAddress.$touch()"
                                                v-on:blur="$v.emailAddress.$touch()"
                                            ></v-text-field>

                                            <v-btn
                                                :disabled="!isDownloadFileLoaded"
                                                :href="downloadFile.blob"
                                                :download="downloadFile.name"
                                                color="primary"
                                                depressed
                                                v-on:click.stop="downloadAreaGuide"
                                            >
                                                Submit
                                            </v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </div>
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-col sm="12" md="6" lg="5" class="py-0">
                        <div class="download-preview-wrapper">
                            <v-img
                                eager
                                :src="getImageUrl(page.downloadPreview)"
                                :alt="getImageAltText(page.downloadPreview)"
                                class="download-preview"
                                position="top left"
                            ></v-img>
                        </div>
                    </v-col>
                </v-row>
            </div>
        </div>
    </div>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators';
import ActivityBlock from '@/components/AreaGuide/ActivityBlock';
import EateryCard from '@/components/AreaGuide/EateryCard';
import OutingPanel from '@/components/AreaGuide/OutingPanel';
import TourCard from '@/components/AreaGuide/TourCard';
import SiteService from '@/services/site.service';
import { getMediaPathUrl, mapCollectionFromCMS } from '@/utils/helpers';

export default {
    name: 'AreaGuides',

    components: {
        ActivityBlock,
        EateryCard,
        OutingPanel,
        TourCard,
    },

    props: {
        schoolSlug: {
            type: String,
            default: undefined,
        },
    },

    data() {
        return {
            page: {
                pageSlug: '',
                areaGuideName: '',
                areaGuideTitle: '',
                areaGuideSubtitle: '',
                areaGuideDescription: '',

                activities: null,
                activitiesTitle: '',
                activitiesDescription: '',

                eateries: null,
                eateriesTitle: '',
                eateriesDescription: '',

                tours: null,
                localToursTitle: '',
                localToursDescription: '',

                outings: null,
                outingsTitle: '',
                outingsDescription: '',
                outingsImage: null,

                downloadTitle: '',
                downloadDescription: '',
                downloadFile: null,
                downloadPreview: null,
            },

            downloadFile: {
                blob: null,
                name: null,
                url: null,
            },

            emailAddress: '',
        }
    },

    validations: {
        emailAddress: { required, email },
    },

    computed: {
        activities() {
            if (! this.isPageLoaded) {
                return [];
            }

            try {
                return mapCollectionFromCMS(this.page?.activities);
            } catch (thrown) {
                return [];
            }
        },

        eateries() {
            if (! this.isPageLoaded) {
                return [];
            }

            try {
                return mapCollectionFromCMS(this.page?.eateries);
            } catch (thrown) {
                return [];
            }
        },

        emailErrors() {
            const errors = [];

            if (this.$v.emailAddress.$dirty) {
                ! this.$v.emailAddress.email && errors.push('Must be a valid E-mail Address');
                ! this.$v.emailAddress.required && errors.push('E-mail Address is required');
            }

            return errors;
        },

        isDownloadFileLoaded() {
            return typeof this.downloadFile.blob === 'string'
                && this.downloadFile.blob.length > 0;
        },

        isPageLoaded() {
            return this.page?.pageSlug?.length > 0;
        },

        navigationButtons() {
            if (! this.isPageLoaded) {
                return [];
            }

            return ([
                { navSection: '#activities', btnTitle: this.page.activitiesTitle },
                { navSection: '#eateries', btnTitle: this.page.eateriesTitle },
                { navSection: '#local-tours', btnTitle: this.page.localToursTitle },
                { navSection: '#outings', btnTitle: this.page.outingsTitle },
                // Temporarily disabled, as the area guide section doesn't have a section for discounts yet.
                // { navSection: '#discounts', btnTitle: `Student Discounts in ${this.page.areaGuideName}` },
                { navSection: '#area-guide-download', btnTitle: this.page.downloadTitle },
            ]).filter((navBtn) => navBtn.btnTitle != null);
        },

        outings() {
            if (! this.isPageLoaded) {
                return [];
            }

            try {
                return mapCollectionFromCMS(this.page?.outings);
            } catch (thrown) {
                return [];
            }
        },

        tours() {
            if (! this.isPageLoaded) {
                return [];
            }

            try {
                return mapCollectionFromCMS(this.page?.tours);
            } catch (thrown) {
                return [];
            }
        },
    },

    watch: {
        schoolSlug: {
            handler: function() {
                this.init();
            },
            immediate: true,
        },
    },

    methods: {
        /**
         * Clear the vuelidate validation for the download area guide form.
         * @returns {void}
         */
        clearDownloadForm() {
            this.$v.$reset();
            this.emailAddress = '';
        },

        /**
         * Handle the download of the area guide file.
         * @param {MouseEvent} event
         */
        downloadAreaGuide(event) {
            // Handle the form validation errors, if any exist
            this.$v.$touch();
            if (this.$v.$invalid) {
                // Prevent the download of the Area Guide File while the email address field is invalid
                event.preventDefault();

                // Scroll to the area guide download form, just in case
                this.scrollToSection('#area-guide-download');

                // Show a snackbar message to the user about the email address
                this.$store.commit('setSnackbar', {
                    show: true,
                    message: 'The mandatory E-mail address field is missing. Please '
                        + 'review the form and fix the E-mail address field highlighted in red',
                    color: 'red',
                });

                // Return without submitting the form
                return;
            }

            // The form is valid, so send the information
            this.$store.dispatch('sendAreaGuideMessage', {
                area: this.page.areaGuideName,
                email: this.emailAddress,
                file: {
                    name: this.downloadFile.name,
                    url: this.downloadFile.url
                },
            }).then(() => {
                // Finally clear the download form
                this.clearDownloadForm();

                // Send the user to the success page
                this.$router.push({ name: 'AreaGuideSuccess', params: {
                    guideName: this.page.areaGuideName,
                }});
            });
        },

        /**
         * Attempt to get a blob from the specified media URL.
         * @param {string} url
         * @returns {Promise<string>}
         */
        async getBlobFromUrl(url) {
            const response = await fetch(url);

            if (! response || typeof response.blob !== 'function') {
                throw new TypeError('The requested data was invalid.');
            }

            return URL.createObjectURL(await response.blob());
        },

        /**
         * Attempt to get the alternative text for the specified image object.
         * @param {Object} image
         * @returns {string}
         */
        getImageAltText(image) {
            try {
                return image?.data?.attributes?.alternativeText || '';
            } catch (thrown) {
                return '';
            }
        },

        /**
         * Attempt to get the file name from the specified image object.
         * @param {Object} image
         * @returns {string}
         */
        getImageName(image) {
            try {
                return image?.data?.attributes?.name || '';
            } catch (thrown) {
                return '';
            }
        },

        /**
         * Attempt to get the file path from the specified image object.
         * @param {Object} image
         * @returns {string}
         */
        getImageUrl(image) {
            try {
                return getMediaPathUrl(image);
            } catch (thrown) {
                return '';
            }
        },

        /**
         * Get the Area Guide data from the CMS and if the dta is not available, navigate back to the default page.
         * @returns {Promise<Route>}
         */
        async init() {
            // Set the menu to transparent
            this.$store.commit('setHeaderMenuState', 'transparent');

            // Check if the download file blob is already set, and revoke the Object URL for it.
            if (this.downloadFile.blob) {
                URL.revokeObjectURL(this.downloadFile.blob);
                this.downloadFile.blob = null;
            }

            const response = await SiteService.getAreaGuidePage(this.schoolSlug);
            if (response == null) {
                return this.$router.push('/');
            }

            // Check that the response returned the page with pageSlug, otherwise return to the home page
            const page = response?.[0]?.attributes;
            const schoolSlug = page?.pageSlug;
            if (page == null || schoolSlug == null) {
                return this.$router.push('/');
            }

            this.page = page;

            // If the download file exists, get the file data and set it
            if (this.page?.downloadFile) {
                // Set the download file data
                const fileUrl = this.getImageUrl(this.page.downloadFile);
                if (fileUrl) {
                    this.getBlobFromUrl(fileUrl)
                        .then((blobUrl) => {
                            this.downloadFile.blob = blobUrl;
                            this.downloadFile.url = fileUrl;
                            this.downloadFile.name = this.getImageName(this.page.downloadFile);
                        });
                }
            }

            // If the school slug wasn't set, or the returned school slug doesn't match, navigate to the correct page.
            if (this.schoolSlug == null || this.schoolSlug !== schoolSlug) {
                return this.$router.push({ name: 'AreaGuides', params: { schoolSlug }});
            }
        },

        /**
         * Scroll to the specified section element on the page.
         * @param {ElementDescriptor} section
         */
        scrollToSection(section) {
            const offset = this.$vuetify.breakpoint.mdAndDown ? -65 : 0;

            this.$scrollTo(section, 500, {
                offset,
            });
        },
    },
};
</script>

<style scoped>
/** Generic Page styles */
>>>.content>.row {
    width: 100%;
    margin: 0;
}

div.area-guide {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
}

div.area-guide .v-btn {
    text-transform: none;
    font-weight: bold;
}

div.area-guide .v-btn .v-icon {
    font-weight: bold;
}

div.area-guide-download .container,
div.hero-banner .container,
div.section .content {
    width: 90%;
    max-width: 1505px;
    padding: 0 20px;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    z-index: 2;
}

div.area-guide-download h2,
div.section h2 {
    font-size: 48px;
    line-height: 1.5;
    margin: 0 auto;
    color: #000;
}

/** Hero Banner styles */
div.hero-banner {
    padding: 180px 0 50px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    max-height: 720px;
    min-height: 630px;
    background-image: url("../../src/assets/media/area-guide-header.jpg");
    background-position: center center;
    background-size: cover;
    width: 100%;
    height: auto;
    position: relative;
    z-index: 1;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
}

div.hero-banner:before {
    position: absolute;
    content: '';
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background-color: rgba(10, 10, 10, 0.75);
    z-index: 1;
}

div.hero-banner h1 {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 700;
    font-size: 64px;
    line-height: 72px;
    max-width: 1300px;
    margin: 0 auto;
}

div.hero-banner h2 {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 700;
    font-size: 26px;
    line-height: 36px;
    margin: 0 auto;
}

/** Section styles */
div.section {
    padding: 100px 0;
}

div.section-dark {
    background-color: #373e55;
}

div.section h2,
div.section p {
    color: #000;
}

div.section-dark h2,
div.section-dark p {
    color: #fff;
}

/** Navigation Buttons styles */
div.navigation-buttons {
    padding: 3% 0;
}

/** Outings Section styles */
div.outings .content .outings-image-wrapper {
    overflow: hidden;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
}

/** Area Guide Download styles */
div.area-guide-download {
    padding: 100px 0;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    max-height: 720px;
    min-height: 630px;
    background-image: url("../../src/assets/media/area-guide-footer.png");
    background-position: top center;
    background-size: cover;
    width: 100%;
    height: auto;
    position: relative;
    z-index: 1;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    overflow: hidden;
}

div.area-guide-download:before {
    position: absolute;
    content: '';
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background-color: rgba(10, 10, 10, 0.75);
    z-index: 1;
}

div.area-guide-download .content .download-content {
    padding: 70px 0 60px 0;
}

div.area-guide-download .content h2 {
    color: #fff;
}

div.area-guide-download .content .email-form {
    padding: 15px;
    background-color: #e3e4e5;
    border-radius: 15px;
}

div.area-guide-download .content .email-form .v-input {
    width: 100%;
    max-width: 78%;
    height: 46px;
    margin-right: 2%;
}

div.area-guide-download .content .email-form .v-input>>>.v-input__slot,
div.area-guide-download .content .email-form .v-input>>>.v-text-field__details {
    margin-bottom: 4px;
}

div.area-guide-download .content .email-form .v-btn {
    width: 100%;
    max-width: 20%;
    height: 46px;
}

div.area-guide-download .download-preview-wrapper {
    margin: 5px 30px -150px;
    overflow: hidden;
    max-height: 615px;
    height: fit-content;
    width: fit-content;
}

@media (max-width: 1400px) {
    div.hero-banner h1 {
        font-size: clamp(30px, 3em, 64px);
        line-height: 1.125;
    }

    div.hero-banner h2 {
        font-size: clamp(15px, 1.5em, 26px);
        line-height: 1.125;
    }
}

@media (max-width: 1024px) {
    div.hero-banner {
        padding: 0;
    }

    div.hero-banner .container {
        margin-top: auto;
        margin-bottom: auto;
        height: 100%;
    }

    div.hero-banner h1 {
        font-size: clamp(30px, 3em, 50px);
    }

    div.hero-banner h2 {
        font-size: clamp(15px, 1.5em, 25px);
    }

    div.area-guide-download .content .download-content {
        padding: 0;
    }

    div.area-guide-download .download-preview-wrapper {
        max-width: 100%;
        margin: 5px 0;
    }
}

@media (max-width: 959px) {
    div.area-guide-download .download-preview-wrapper {
        display: none;
    }
}

@media (max-width: 768px) {
    div.hero-banner .container,
    div.section .content,
    div.area-guide-download .content {
        max-width: 100%;
    }

    div.hero-banner {
        padding-top: 100px;
        padding-bottom: 70px;
        min-height: 200px;
        height: auto;
    }

    div.hero-banner h1 {
        font-size: clamp(30px, 2em, 50px);
    }

    div.hero-banner h2 {
        font-size: clamp(15px, 1em, 25px);
    }
}

@media (max-width: 575px) {
    div.hero-banner h1 {
        font-size: 30px;
    }

    div.hero-banner h2 {
        font-size: 15px;
    }
}

@media (max-width: 450px) {
    .v-application .mb-10 {
        margin-bottom: 0px !important;
    }
}
</style>
